export default __webpack_public_path__ + "static/media/visit_report.abe8f0ba.svg";